import React from "react";
import { formatNumber } from "../../Helper/Helper";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { FlinkContext } from "../../context/FlinkContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { aheadDates } from "../../Helper/bigTableDates";
import "./Table.scss";
import { useContext } from "react";

export default function AheadTable({ firstThName, data, openModal }) {
  const element = <FontAwesomeIcon icon={faExternalLink} />;
  const powerData = useContext(FlinkContext);

  const formatDateHead = (num) => {
    if (num) {
      const d = new Date(num);
      const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
      const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(d);
      const newDate = `${da} ${mo}`;
      return newDate;
    }

    return "";
  };

  return (
    <div className="NbpPricesTable">
      <div className="table-container table-full-size">
        <table className="total-table total-table-stripped table-sm">
          <thead>
            <tr>
              <th className="singl">{firstThName}</th>
              <th>{aheadDates[0]}</th>
              <th>{aheadDates[1]}</th>
              {/* <th>{formatDateHead(powerData?.power?.powerTable?.date3)}</th> */}
              {/* <th>{formatDateHead(powerData?.power?.powerTable?.date4)}</th> */}
              <th>Daily % </th>
              <th>Weekly %</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((row, index) => {
              return (
                <tr key={index}>
                  <>
                    {row.col1 === "Day-Ahead" && (
                      <td className="Ahead" onClick={openModal}>
                        <button className="btn external">
                          {row.col1} &nbsp; <span>{element}</span>
                        </button>
                      </td>
                    )}
                    <td>{formatNumber(row.col2)}</td>
                    <td>{formatNumber(row.col3)}</td>
                    <td style={{ color: `${row.col9 < 0 ? "green" : "red"}` }}>
                      {formatNumber(row.col9)}%
                    </td>
                    <td style={{ color: `${row.col10 < 0 ? "green" : "red"}` }}>
                      {formatNumber(row.col10)}
                    </td>
                  </>
                </tr>
              );
            })}
          </tbody>
        </table>
        <p className="tablenote">*Note: Published Data is on Trading Day</p>
      </div>
    </div>
  );
}
